import { tokens } from '@fluentui/react-components';
import { themeVar } from '../theme/themeConfig';

export const HEADER_BACKGROUND = themeVar(
  'table',
  'headerBackground',
  tokens.colorBrandBackground
);

export const HEADER_TEXT = themeVar(
  'table',
  'headerText',
  tokens.colorNeutralForegroundOnBrand
);

export const ROW_HOVER = themeVar(
  'table',
  'rowHover',
  tokens.colorSubtleBackgroundHover
);

export const GRID_BORDER = themeVar(
  'card',
  'border',
  `1px solid ${tokens.colorNeutralStroke2}`
);

export const GRID_RADIUS = themeVar(
  'card',
  'borderRadius',
  tokens.borderRadiusLarge
);
